import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Produto } from 'src/app/core/models/produto.model';
import { InputNumberInputEvent } from 'primeng/inputnumber';
import { NovoPedidoAnexoRequest, NovoPedidoProdutoRequest } from 'src/app/core/models/request/novo-pedido.request.model';
import { Loja } from 'src/app/core/models/loja.model';
import { Cliente } from 'src/app/core/models/cliente.model';
import { ClienteResponse } from 'src/app/core/models/response/cliente-response.model';
import { Medico, MedicoResponse } from 'src/app/core/models/medico.model';
import { TableSelectColumn } from 'src/app/shared/components/table-select/table-select.component';
import { WeblabService } from 'src/app/core/services/weblab.service';
import { ToastrService } from 'ngx-toastr';
import { Genero, GenerosResponse } from 'src/app/core/models/response/generos-response.model';
import { Cidade, CidadesResponse } from 'src/app/core/models/response/cidades-response.model';
import { EnderecoResponse } from 'src/app/core/models/response/endereco-response.model';
import { AnexoUploadService } from 'src/app/core/services/anexo-upload.service';
import { FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'app-ordem-de-servico',
  templateUrl: './ordem-de-servico.component.html',
  styleUrls: ['./ordem-de-servico.component.scss']
})
export class OrdemDeServicoComponent implements OnInit {
  @Input() comboOutrosServicos: Produto[] = [];
  @Input() servicosAdicionados: Produto[] = [];
  @Input() produtosLentes: Array<Produto>;
  @Input() laboratorioSelecionado: Loja | undefined;
  @Input() os_numero_readonly: boolean = false;
  @Input() anexosExistentes: any[] = [];

  @Input() dadosForm: any;

  @Output() NumeroOSChange = new EventEmitter<string>();
  @Output() removerAnexoExistente = new EventEmitter<any>();

  @ViewChild('fileUpload') fileUpload?: FileUpload;

  maxDate: Date = new Date();
  duplicarSelecionado: Produto;
  produtoDuplicado: Array<Produto> = [];
  handlerChecarNumeroOS: any = null;
  pacientes: Array<Cliente> = [];
  loadingPacientes: boolean = false;

  medicos: Array<Medico> = [];
  loadingMedicos: boolean = false;

  modalCadastrarMedico = false;
  loadingMedico = false;
  enderecoMedicoLoading = false;
  listagemGeneros: Genero[] = [];
  listagemCidadesMedico: Cidade[] = [];

  dadosMedico = {
    pessoa: 'F',
    genero: null as string | null,
    crm: null as string | null,
    aniversario_dia: null as number | null,
    aniversario_mes: null as number | null,
    nome: null as string | null,
    nome_social: null as string | null,
    contato: null as string | null,
    telefone: null as string | null,
    celular: null as string | null,
    email: null as string | null,
    endereco: {
      cep: null as string | null,
      logradouro: null as string | null,
      numero: null as string | null,
      complemento: null as string | null,
      bairro: null as string | null,
      cod_cidade: null as Cidade | null
    }
  };
  resetDadosMedico: any;

  colunasMedicos: TableSelectColumn[] = [
    { field: 'nome', header: 'Nome Completo' },
    { field: 'crm', header: 'CRM' },
  ];

  colunasPacientes: TableSelectColumn[] = [
    { field: 'nome_completo', header: 'Nome Completo' },
    { field: 'cpf', header: 'CPF/CNPJ', format: (v) => {
      if (!v) return '';
      const s = String(v).replace(/\D/g, '');
      if (s.length <= 11)
        return `${s.substr(0,3)}.${s.substr(3,3)}.${s.substr(6,3)}-${s.substr(9)}`;
      return `${s.substr(0,2)}.${s.substr(2,3)}.${s.substr(5,3)}/${s.substr(8,4)}-${s.substr(12)}`;
    }},
  ];

  tiposMontagem: any[] = [
    {
      id: 1,
      nome: 'Aro fechado'
    },
    {
      id: 2,
      nome: 'Meio Aro (Fio de Nylon)'
    },
    {
      id: 3,
      nome: 'Três peças (Balgriff)'
    },
    {
      id: 4,
      nome: 'Esportiva'
    }
  ];

  
  maxlength: number = 5;

  constructor(
    private service: WeblabService,
    private toastr: ToastrService,
    private anexoUploadService: AnexoUploadService
  ) { }

  ngOnInit(): void {
    this.dadosForm.oldNumeroOS = this.dadosForm.numeroOS;
    this.resetDadosMedico = JSON.parse(JSON.stringify(this.dadosMedico));
    this.carregarGeneros();
  }

  async carregarGeneros() {
    try {
      const res = await new Promise((resolve, reject) => this.service.generos().subscribe({ next: resolve, error: reject }));
      this.listagemGeneros = (res as GenerosResponse)?.dados || [];
    }
    catch(e) {
      console.error(e);
    }
  }

  DnpLongeEsquerdoChange($event: boolean) {
    this.calcularReceita();
  }

  DnpLongeDireitoChange($event: boolean) {
    this.calcularReceita();
  }

  armacaoChange($event: InputNumberInputEvent) {
    this.calcularReceita();
  }

  calcularReceita() {
    let olhoEsquerdo = this.dadosForm.olhoEsquerdo;
    let olhoDireito = this.dadosForm.olhoDireito;  
    
    setTimeout(() => {
      let esquerdoDNPLonge = olhoEsquerdo?.olhoLongeDNP ?? '';
      let direitoDNPLonge = olhoDireito?.olhoLongeDNP ?? '';

      let menorDNP = esquerdoDNPLonge > direitoDNPLonge ?
        direitoDNPLonge : esquerdoDNPLonge;

      let diametroApurado =
        (this.dadosForm.armacao?.armacaoPonte ?? 0) +
        (this.dadosForm.armacao?.armacaoAro ?? 0) +
        (this.dadosForm.armacao?.armacaoDiagMaior ?? 0) -
        (2 * (Number(menorDNP.toString().replace(',', '.')))) + 2;

      if (diametroApurado > 0) {
        diametroApurado = diametroApurado;
      }
      else {
        diametroApurado = 0;
      }

      this.dadosForm.armacao.armacaoDiamApurado = diametroApurado;

      let esquerdoDNPL = Number(esquerdoDNPLonge.toString().replace(',', '.'));
      let direitoDNPL = Number(direitoDNPLonge.toString().replace(',', '.'));
      
      if ( esquerdoDNPL > 0 && direitoDNPL > 0) {
        let distanciaPupilar = esquerdoDNPL + direitoDNPL;
        // this.dadosForm.armacao.armacaoDistPupilar = Math.round(distanciaPupilar)
        this.dadosForm.armacao.armacaoDistPupilar = this.formatarInputBlur(distanciaPupilar);
      }

    }, 500);

  }

  formatarInputBlur(input: any) {

    const formatoNovo = input.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2});

    return formatoNovo

  }
  
  formatarInput(input: any, campo?: string): void {
    const inputNumericValue = input.value.replace(/[^\d.-]/g, '');
    const isNegative = inputNumericValue.startsWith('-');
    const isPositive = !isNegative;
    
    if (isPositive || isNegative) {
      let number = parseFloat(inputNumericValue) / 100;

      let formattedValue = number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      if (formattedValue === 'NaN') {
          formattedValue = '-';
      }
      input.value = formattedValue;

    } else {
        input.value = '';
    }

  }

  parseNumber(value: string) {
    return Number((value ?? '0').replace('.', '').replace(',', '.'));
  }

  changeProduto(produto: Produto, tipo: string) {
    let index = this.servicosAdicionados.findIndex(x => x.tipo_prod === tipo);
    if (index >= 0) {
      this.servicosAdicionados.splice(index, 1);
    }

    if (produto && typeof produto != "string") {
      const servico = JSON.parse(JSON.stringify(produto));
      servico.tipo_prod = tipo;
      servico.quantidadeAdd = 1;
      this.servicosAdicionados.push(servico);
      this.duplicarProduto(servico, produto);
    }
  }

  existeTipo(tipo: "E" | "D") {
    return !!this.servicosAdicionados.find(p => p.tipo_prod == tipo);
  }

  duplicarProduto(servico: Produto, produto: Produto) {
    if (!servico || !["E", "D"].includes(servico.tipo_prod) || this.dadosForm.opcaoOlhoSelecionado != 'ambos') {
      return;
    }

    const clone_produto = JSON.parse(JSON.stringify(servico));
    clone_produto.tipo_prod = produto.tipo_prod == "E" ? "D" : "E";
    if (!this.existeTipo(clone_produto.tipo_prod)) {
      this.servicosAdicionados.push(clone_produto);
      if (clone_produto.tipo_prod == "D") {
        this.dadosForm.olhoDireito.olhoLente = produto;
      }
      else {
        this.dadosForm.olhoEsquerdo.olhoLente = produto;
      }
    }
  }

  removerProdutosTipos(tipos: string[] = ['D', 'E']) {
    let eof = true;
    do {
      eof = true;
      for (let i = 0; i < this.servicosAdicionados.length; i++) {
        const service = this.servicosAdicionados[i];
        if (tipos.includes(service.tipo_prod)) {
          this.servicosAdicionados.splice(i, 1);
          eof = false;
          break;
        }
      }
    } while(!eof);
  }

  verificarProduto(tipo?: string) {
    if (tipo == 'E') {
      this.removerProdutosTipos(['D']);
      this.dadosForm.olhoDireito = {};
    }
    else if (tipo == 'D') {
      this.removerProdutosTipos(['E']);
      this.dadosForm.olhoEsquerdo = {};
    }
    else {
      this.removerProdutosTipos(['D', 'E']);
      this.dadosForm.olhoDireito = {};
      this.dadosForm.olhoEsquerdo = {};
    }

    this.duplicarSelecionado = undefined as any;
    this.produtoDuplicado = this.servicosAdicionados;
  }

  async onAnexosSelect(event: any) {
    const files = Array.from(event.files) as File[];
    const quantidadeJaAnexada = (this.anexosExistentes?.length || 0) + (this.dadosForm.anexos?.length || 0);
    const novosAnexos = await this.anexoUploadService.processarSelecao(files, quantidadeJaAnexada);
    this.dadosForm.anexos = (this.dadosForm.anexos || []).concat(novosAnexos);
  }

  onAnexosRemove(event: any) {
    this.dadosForm.anexos = this.dadosForm.anexos?.filter((a: any) => a.ref != event.file);
  }

  onAnexosClear(event: any) {
    this.dadosForm.anexos = [];
  }

  limparAnexos() {
    this.fileUpload?.clear();
  }

  fileToBase64(file: File) {
    return new Promise<any>((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        //@ts-ignore
        const base64 = reader.result?.split(',')[1];
        resolve(base64);
      };

      reader.onerror = error => reject(error);
    });
  }

  checarNumeroOS() {
    const self = this;
    clearTimeout(this.handlerChecarNumeroOS);
    this.handlerChecarNumeroOS = setTimeout(() => {
      const numero = self.dadosForm.numeroOS;
      if (numero != self.dadosForm.oldNumeroOS) {
        self.dadosForm.oldNumeroOS = numero;
        self.NumeroOSChange.emit(numero);
      }
    }, 500);
  }

  async buscarPacientes(event: any) {
    const self = this;
    const search = event?.query || "";
    let clientes: Cliente[] = [];
    self.loadingPacientes = true;
    try {
      const dadosClientes = await new Promise((resolve, reject) => self.service.buscarClientes(search).subscribe({ next: resolve, error: reject }));
      clientes = (dadosClientes as ClienteResponse)?.dados;
    }
    catch(e) {
      console.error(e);
    }
    finally {
      self.loadingPacientes = false;
    }
    
    self.pacientes = clientes?.sort((a, b) => {
      const nameA = a.nome_completo.replace(/\s/g, "").toUpperCase(); // ignore upper and lowercase
      const nameB = b.nome_completo.replace(/\s/g, "").toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });
  }

  async buscarMedicos(event: any) {
    const self = this;
    const nome = (event?.query || "").trim();
    const crm = (event?.secondaryQuery || "").trim();
    let medicos: Medico[] = [];
    self.loadingMedicos = true;
    try {
      const dados = await new Promise((resolve, reject) => self.service.buscarMedicos(crm, nome).subscribe({ next: resolve, error: reject }));
      medicos = (dados as MedicoResponse)?.dados || [];
    }
    catch(e) {
      console.error(e);
    }
    finally {
      self.loadingMedicos = false;
    }
    self.medicos = medicos.sort((a, b) => a.nome.localeCompare(b.nome));
  }

  maskDate(e: any) {
    let input = e?.target;
    if (!input) return;

    let value = (input.value || "").toString();

    if (/^(\w{2})(\w{1})$/.test(value)) {
      value = value.replace(/^(\w{2})(\w{1})$/, "$1/$2");
    }
    else if (/(^\w{2}\/\w{2})(\w{1})$/.test(value)) {
      value = value.replace(/(^\w{2}\/\w{2})(\w{1})$/, "$1/$2");
    }

    input.value = value;
  }

  novoMedico() {
    this.dadosMedico = JSON.parse(JSON.stringify(this.resetDadosMedico));
    this.listagemCidadesMedico = [];
    this.modalCadastrarMedico = true;
  }

  validarMedico(): boolean {
    if (!this.dadosMedico.nome?.trim()) {
      this.toastr.error('O campo "Nome completo" é obrigatório.');
      return false;
    }
    if (!this.dadosMedico.crm?.trim()) {
      this.toastr.error('O campo "CRM" é obrigatório.');
      return false;
    }
    const email = (this.dadosMedico.email || '').trim();
    if (email) {
      const partes = email.split('@');
      if (partes.length !== 2 || !partes[0] || !partes[1] || !partes[1].includes('.')) {
        this.toastr.error('O e-mail informado não é válido.');
        return false;
      }
    }
    return true;
  }

  async salvarMedico() {
    if (!this.validarMedico()) return;

    this.loadingMedico = true;
    try {
      const data: any = JSON.parse(JSON.stringify(this.dadosMedico));
      data.endereco.cod_cidade = data.endereco.cod_cidade && typeof data.endereco.cod_cidade === 'object'
        ? data.endereco.cod_cidade.id
        : data.endereco.cod_cidade;
      data.endereco.cep = data.endereco.cep?.replace(/[^\d]+/g, '')?.slice(0, 8) || null;
      data.telefone = data.telefone?.replace(/[^\d]+/g, '') || null;
      data.celular = data.celular?.replace(/[^\d]+/g, '') || null;

      const response: any = await new Promise((resolve, reject) =>
        this.service.cadastrarMedico(data).subscribe({ next: resolve, error: reject })
      );

      if (response?.dados) {
        const medico: Medico = response.dados;
        this.medicos = [medico];
        this.dadosForm.medico = medico;
      }

      this.toastr.success('Médico salvo com sucesso!');
      this.modalCadastrarMedico = false;
    }
    catch(e: any) {
      console.error(e);
      const message = e?.error?.erro?.mensagem || e.message;
      this.toastr.error('Erro ao salvar médico. ' + message);
    }
    finally {
      this.loadingMedico = false;
    }
  }

  async buscarEnderecoMedico() {
    const cep = (this.dadosMedico.endereco.cep || '').toString().replace(/[^\d]+/g, '');
    if (cep.length < 8) return;

    const self = this;
    try {
      this.enderecoMedicoLoading = true;
      const endereco: EnderecoResponse = await new Promise((resolve, reject) =>
        self.service.buscarEndereco(cep).subscribe({ next: resolve, error: reject })
      );
      if (endereco.sucesso && endereco.dados?.bairro) {
        this.dadosMedico.endereco.bairro = endereco.dados.bairro.substring(0, 30);
        this.dadosMedico.endereco.logradouro = endereco.dados.logradouro;

        if (endereco.dados.codigo_ibge) {
          const cidade = await this.buscarCidadeMedicoIBGE(endereco.dados.codigo_ibge);
          this.dadosMedico.endereco.cod_cidade = cidade as any;
          this.listagemCidadesMedico = cidade ? [cidade] : [];
        }
      }
    }
    catch(e) {
      console.error(e);
    }
    finally {
      this.enderecoMedicoLoading = false;
    }
  }

  async buscarCidadeMedicoIBGE(ibge: string): Promise<Cidade | undefined> {
    try {
      const res = await new Promise((resolve, reject) =>
        this.service.cidades(ibge, undefined, 1, 1).subscribe({ next: resolve, error: reject })
      );
      return ((res as CidadesResponse)?.dados || [])[0];
    }
    catch(e) {
      console.error(e);
      return undefined;
    }
  }

  async buscarCidadesMedico(event: any) {
    const search = event?.query || '';
    if (!search || search.length < 3) {
      this.listagemCidadesMedico = [];
      return;
    }
    try {
      const res = await new Promise((resolve, reject) =>
        this.service.cidades(undefined, search).subscribe({ next: resolve, error: reject })
      );
      this.listagemCidadesMedico = (res as CidadesResponse)?.dados || [];
    }
    catch(e: any) {
      const codigo = e?.error?.erro?.codigo;
      if (codigo !== 'BUSCA_INVALIDA') {
        this.toastr.error('Erro ao buscar cidades. ' + (e?.error?.erro?.mensagem || e.message));
      }
      this.listagemCidadesMedico = [];
    }
  }
}
